import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Plus, Crown, Lightbulb } from "lucide-react";
import { http } from "../lib/api";
import { useRetailCart } from "../contexts/RetailCartContext";
import { ProductImage } from "../components/ProductImage";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const { add, count } = useRetailCart();
  useEffect(() => { http.get("/products").then(({ data }) => setProducts(data.products)); }, []);
  return (
    <div className="bg-[#FFFDF8]" data-testid="shop-root">
      <div className="bg-gradient-to-r from-[#D32F2F] via-[#B71C1C] to-[#1A1A1A] text-white" data-testid="shop-promo-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-10 flex flex-wrap items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <div className="text-5xl md:text-6xl">🎁</div>
            <div>
              <div className="font-heading text-3xl md:text-4xl uppercase tracking-wide leading-none">Buy 3, get 1 FREE</div>
              <div className="text-sm md:text-base text-[#FFB300] mt-1">Every 3 chilito candies unlocks an extra mixed chamoy surprise, on us</div>
            </div>
          </div>
          {count > 0 && (
            <Link to="/cart" className="bg-[#FFB300] text-[#1A1A1A] px-6 py-3 uppercase tracking-widest font-heading text-sm hover:bg-white transition-colors flex items-center gap-2" data-testid="shop-promo-cta">
              View bag ({count}) <ChevronRight size={16} />
            </Link>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-14 pb-8">
        <div className="text-xs tracking-[0.3em] uppercase text-[#D32F2F] mb-3">Shop retail</div>
        <h1 className="font-heading text-6xl md:text-7xl uppercase tracking-wide">Our treats</h1>
        <p className="text-lg text-[#5C5A56] mt-6 max-w-2xl">All chilito candy, ready to ship. Buy one or stock the pantry. Wholesalers → <Link to="/wholesale" className="text-[#D32F2F] font-semibold">apply here</Link> for case pricing.</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Link to="/club" className="inline-flex items-center gap-2 border-2 border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white px-4 py-2 uppercase tracking-widest text-xs font-heading transition-colors" data-testid="shop-club-cta"><Crown size={14} /> Join Chamoy Club · $20/mo</Link>
          <Link to="/request" className="inline-flex items-center gap-2 border-2 border-[#1A1A1A] hover:bg-[#FFB300] px-4 py-2 uppercase tracking-widest text-xs font-heading transition-colors" data-testid="shop-request-cta"><Lightbulb size={14} /> Request a candy</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
        {products.map((p, i) => (
          <div key={p.id} className="group flex flex-col" data-testid={`shop-card-${p.id}`}>
            <div className="relative">
              <Link to={`/product/${p.id}`} className={`aspect-square ${["bg-[#FDF4E3]", "bg-[#FFB300]/25", "bg-[#D32F2F]/10"][i % 3]} flex items-center justify-center overflow-hidden border border-[#E5D8C1] relative`}>
                <ProductImage p={p} className="group-hover:scale-105 transition-transform duration-500" />
              </Link>
              {!p.coming_soon && (
                <div className="absolute -top-3 -left-3 bg-[#1A1A1A] text-[#FFB300] text-[10px] uppercase tracking-widest px-2.5 py-1 font-heading rotate-[-6deg] shadow-lg">3+1 free</div>
              )}
            </div>
            <div className="mt-5 flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <Link to={`/product/${p.id}`}><div className="font-heading text-2xl uppercase tracking-wide leading-tight hover:text-[#D32F2F]">{p.name}</div></Link>
                <div className="text-sm text-[#5C5A56] mt-1">{p.tagline}</div>
                <div className="text-xs text-[#5C5A56] mt-2 uppercase tracking-wider">{p.size_oz} oz chilito candy</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-heading text-3xl text-[#D32F2F]">${p.retail_msrp?.toFixed(2)}</div>
                <div className="text-[10px] tracking-widest uppercase text-[#5C5A56]">each</div>
              </div>
            </div>
            <button
              disabled={!!p.coming_soon}
              onClick={() => !p.coming_soon && add(p.id, 1)}
              className="mt-4 bg-[#D32F2F] text-white hover:bg-[#B71C1C] hover:-translate-y-1 py-3 uppercase tracking-widest text-sm font-heading transition-transform disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              data-testid={`shop-add-${p.id}`}
            >
              {p.coming_soon ? "Coming soon" : (<><Plus size={16} /> Add to bag</>)}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
